import Request from "lib/request";

export const init = () => {
  return Request({
    url: "init",
    method: "get"
  });
};